import React, { useEffect, useMemo, useState } from "react";
import { Container, Row, Col, Card, CardBody, Button } from "reactstrap";
import { formContentContainer, loaderOverlay } from "../../Style/loaderOverly";
import { AvForm } from "availity-reactstrap-validation";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { createPageData, outwardFormData } from "./InstallationApprovalFile";
import { LoaderCreatePage } from "../Loader/Loader";
import {
  baseURL,
  DownloadPDFData,
  formatDate,
  formatNumber,
  getRecords,
} from "../../services/api.service";
import { toast } from "react-toastify";
import TextAreaInput from "../../custom/components/TextArea-Input/TextAreaInput";
import InstallationApprovalPDF from "./InstallationApprovalPDF/InstallationApprovalPDF";

const InstallationApprovalView = () => {
  const breadcrumbItems = [];
  const { id } = useParams();
  const navigate = useNavigate();
  const location = useLocation();

  const { payload, navigatePage, headerName, getEndpoint } = createPageData();
  const initialPayload = useMemo(() => payload, []);
  const [loadingData, setLoadingData] = useState(id ? true : false);
  const [formData, setFormData] = useState(outwardFormData());
  const [fetchedData, setFetchedData] = useState(null);
  const [searchQuery, setSearchQuery] = useState("");
  const [groupedItems, setGroupedItems] = useState({});
  const [remark, setRemark] = useState("");

  let serialNumber = 1;

  useEffect(() => {
    if (id) {
      getEditData(id);
    }
  }, [id]);

  useEffect(() => {
    if (fetchedData) {
      let data = fetchedData[0];

      const updatedListDetails = data?.list_details?.map((item) => ({
        item_id: item?.item_id,
        buy_item_id: item?.buy_item_id,
        item_code: item?.item_code,
        buy_item_code: item?.buy_item_code,
        description: item?.buy_item_desc,
        uom: item.buy_item_uom,
        make_item_desc: item?.item_description,

        make_item_uom: item.uom,
        // stock_qty: item?.stock_qty,
        required_qty: item?.required_qty,
        assigned_qty: item?.assigned_qty,
        already_installed_qty: item?.already_installed_qty,
        installed_qty: item?.install_qty,
        type: item?.is_make_item ? 1 : 2,
        is_make_item: item?.is_make_item,
        is_active: item?.is_active,
        id: item.id,
        make_buy_name: item?.is_make_item
          ? item?.buyItem?.item_code + " (" + item?.makeItem?.item_code + ")"
          : item?.buyItem?.item_code,
      }));

      setFormData((prevState) => ({
        ...prevState,
        inputData: {
          ...prevState.inputData,
          ...data,
          list_details: updatedListDetails,
        },
      }));
    }
  }, [fetchedData]);

  const getEditData = async (Id) => {
    try {
      const projectId = JSON.parse(localStorage?.getItem("projectID"));
      const contractor_id = JSON.parse(localStorage.getItem("userDetails"))?.id;
      const payload = {
        modelName: "installation_commissioning_list_masters",
        listInstallation: true,
        contractor_id: contractor_id,
        assignedTo: contractor_id,
        status: "installation_completed",
        id: Id,
        whereCondition: {
          project_id: projectId,
          type: 1,
        },
        pagination: { page: 1, pageSize: 100000 },
      };
      const responseData = await getRecords(payload, "/listInstallation");

      if (responseData?.code == 1) {
        const data = responseData?.data;
        setFetchedData(data);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoadingData(false);
    }
  };

  const FloatValue = (value) => {
    return parseFloat(value);
  };

  // Filter items based on search query
  const filteredItems =
    formData?.inputData?.list_details?.filter(
      (item) =>
        item?.item_code?.toLowerCase().includes(searchQuery.toLowerCase()) ||
        item?.buy_item_code?.toLowerCase().includes(searchQuery.toLowerCase())
    ) || [];

  useEffect(() => {
    if (!filteredItems || filteredItems.length === 0) return;

    const grouped = filteredItems.reduce((acc, item) => {
      if (!acc[item.item_code]) {
        acc[item.item_code] = {
          makeItem: { ...item, unique_id: `${item.item_code}-${item.id}` },
          buyItems: [],
        };
      }

      if (item.buy_item_code) {
        acc[item.item_code].buyItems.push({
          ...item,
          unique_id: `${item.buy_item_code}-${item.id}`,
        });
      }

      return acc;
    }, {});

    setGroupedItems(grouped);
  }, [filteredItems]);

  const handleApproveRejectInstallation = async (type) => {
    try {
      if (!remark || remark == "") {
        toast.error("Please enter a remark before proceeding.");
        return;
      }
      const projectId = JSON.parse(localStorage?.getItem("projectID"));
      const approved_by = JSON.parse(localStorage.getItem("userDetails"))?.id;

      let payload = {
        modelName: "installations",
        id: id,
        inputData: {
          status:
            type == "approve"
              ? "installation_approved"
              : "installation_rejected",
          approved_by: approved_by,
          approval_remark: remark,
        },
      };

      const responseData = await getRecords(payload, "/updaterelationaldata");
      if (type == "approve") {
        toast.success("Installation Approved Successfully");
        navigate("/installation-approval-list");
      } else {
        toast.error("installation Rejected Successfully");
        navigate("/Installation-approval-list");
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoadingData(false);
    }
  };
  const onInputChange = (e) => {
    const { name, value, type, checked } = e.target;

    setRemark(value);
  };

  const handleImageClick = (imageSrc) => {
    window.open(imageSrc, "_blank");
  };
  const navigateBack = () => {
    if (location.state?.fromDashboard) {
      navigate("/dashboard");
    } else {
      navigate("/installation-approval-list");
    }
  };
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          <Row>
            <Col xl="12">
              <Card>
                <CardBody>
                  <div style={formContentContainer}>
                    <AvForm className="needs-validation">
                      <div className="card mt-4">
                        <div className="card-header">
                          <h5>Installation Approval Details</h5>
                          <Button
                            style={{ marginLeft: "10px" }}
                            color="secondary"
                            className="waves-effect waves-light me-1 back-button"
                            onClick={navigateBack}
                          >
                            Back
                          </Button>
                          <Button
                            color="success"
                            className="waves-effect waves-light me-1 back-button ml-2"
                            style={{ borderRadius: "50%" }}
                            onClick={() =>
                              DownloadPDFData("InstallationApprovalDetails.pdf")
                            }
                          >
                            <i class="fas fa-download"></i>
                          </Button>
                        </div>
                        <div className="card-body">
                          <Row>
                            {/* First Section (Left Side) */}
                            <Col
                              md="6"
                              className="border-end border-secondary p-3"
                            >
                              <p>
                                <strong>Project Name: </strong>
                                {formData?.inputData?.installations
                                  ?.projectDetails ? (
                                  <span>
                                    {formData?.inputData?.installations
                                      ?.projectDetails?.project_name || "-"}
                                  </span>
                                ) : (
                                  "-"
                                )}
                              </p>
                              <p>
                                <strong>Installation No: </strong>
                                {formData?.inputData?.installations
                                  ?.installation_no ? (
                                  <span>
                                    {
                                      formData?.inputData?.installations
                                        .installation_no
                                    }
                                  </span>
                                ) : (
                                  "-"
                                )}
                              </p>
                              <p>
                                <strong>Form Name: </strong>
                                {formData?.inputData?.form_name ? (
                                  <span>{formData?.inputData?.form_name}</span>
                                ) : (
                                  "-"
                                )}
                              </p>
                              <p>
                                <strong>Field Name: </strong>
                                {formData?.inputData?.installations
                                  ?.field_name ? (
                                  <span>
                                    {
                                      formData?.inputData?.installations
                                        ?.field_name
                                    }
                                  </span>
                                ) : (
                                  "-"
                                )}
                              </p>
                            </Col>
                            <Col md="6" className="p-3">
                              <p>
                                <strong>Installation Status: </strong>
                                <span className="text-uppercase">
                                  {formData?.inputData?.installations?.status
                                    ? formData?.inputData?.installations
                                        ?.status === "installation_rejected"
                                      ? "Installation Rejected"
                                      : formData?.inputData?.installations
                                          ?.status === "installation_approved"
                                      ? "Installation Approved"
                                      : formData?.inputData?.installations
                                          ?.status === "installation_completed"
                                      ? "Installation Completed"
                                      : formData?.inputData?.installations
                                          ?.status
                                    : "-"}
                                </span>
                              </p>

                              <p>
                                <strong>Status: </strong>
                                {formData?.inputData?.is_active
                                  ? "ACTIVE"
                                  : "IN-ACTIVE" || "-"}
                              </p>
                              <p>
                                <strong>Created By: </strong>
                                {formData?.inputData?.installations
                                  ?.createdByUser ? (
                                  <span>
                                    {formData?.inputData?.installations
                                      ?.createdByUser?.first_name +
                                      " " +
                                      formData?.inputData?.installations
                                        ?.createdByUser?.last_name}
                                  </span>
                                ) : (
                                  "-"
                                )}
                              </p>
                              <p>
                                <strong>Created Date: </strong>
                                {formData?.inputData?.installations
                                  ?.createdAt ? (
                                  <span>
                                    {formatDate(
                                      formData?.inputData?.installations
                                        ?.createdAt
                                    )}
                                  </span>
                                ) : (
                                  "-"
                                )}
                              </p>
                            </Col>
                          </Row>
                        </div>
                      </div>

                      <Row className="mt-4">
                        <div className="item-list-container">
                          <div className="d-flex justify-content-between align-items-center">
                            <h6 className="h-6-heading">Item Details</h6>
                            <div className="app-search d-flex d-lg-inline mt-0 p-0">
                              <div className="position-relative">
                                <input
                                  type="text"
                                  className="form-control ps-5"
                                  placeholder="Search by item code..."
                                  value={searchQuery}
                                  onChange={(e) =>
                                    setSearchQuery(e.target.value)
                                  }
                                  style={{
                                    width: "13rem",
                                    padding: "8px 15px",
                                    borderRadius: "8px",
                                    borderColor: "#D2D2D2",
                                    outline: "none",
                                    transition: "all 0.3s ease",
                                    boxShadow: "none",
                                    marginRight: "0.5rem",
                                  }}
                                />
                                <span className="ri-search-line"></span>
                              </div>
                            </div>
                          </div>
                          <div
                            className="table mt-2"
                            style={{
                              overflowX: "auto",
                              overflowY: "auto",
                              maxHeight: "500px",
                              width: "100%",
                              scrollBehavior: "smooth",
                              scrollbarWidth: "thin",
                              msOverflowStyle: "none",
                              zIndex: 0,
                            }}
                          >
                            <table className="table table-hover">
                              <thead
                                style={{
                                  position: "sticky",
                                  top: 0,
                                  backgroundColor: "#8AC1E8",
                                  zIndex: 1,
                                }}
                              >
                                <tr style={{ borderBottom: "1px solid black" }}>
                                  <th style={{ whiteSpace: "nowrap" }}>
                                    Sr. No
                                  </th>
                                  <th
                                    style={{
                                      width: "18%",
                                      whiteSpace: "nowrap",
                                    }}
                                  >
                                    Item Code
                                  </th>

                                  <th
                                    style={{
                                      width: "18%",
                                      whiteSpace: "nowrap",
                                    }}
                                  >
                                    Item Description
                                  </th>
                                  <th
                                    style={{
                                      width: "15%",
                                      whiteSpace: "nowrap",
                                    }}
                                  >
                                    UOM
                                  </th>
                                  <th
                                    style={{
                                      whiteSpace: "nowrap",
                                      width: "15%",
                                    }}
                                  >
                                    Required Qty
                                  </th>
                                  <th
                                    style={{
                                      whiteSpace: "nowrap",
                                      width: "15%",
                                    }}
                                  >
                                    Assigned Qty
                                  </th>
                                  <th
                                    style={{
                                      whiteSpace: "nowrap",
                                      width: "15%",
                                    }}
                                  >
                                    Installed Qty
                                  </th>
                                </tr>
                              </thead>

                              <tbody>
                                {Object.values(groupedItems)?.length === 0 ? (
                                  <tr>
                                    <td
                                      colSpan="10"
                                      style={{ textAlign: "center" }}
                                    >
                                      No data available.
                                    </td>
                                  </tr>
                                ) : (
                                  Object.values(groupedItems)?.map(
                                    (group, index) => (
                                      <React.Fragment
                                        key={group.makeItem.unique_id}
                                      >
                                        {group.makeItem.is_make_item && (
                                          <tr
                                            style={{
                                              fontWeight: "bold",
                                              backgroundColor: "#f0f8ff",
                                            }}
                                          >
                                            <td>{serialNumber++}</td>
                                            <td
                                              style={{
                                                paddingLeft: "10px",
                                                paddingRight: "2px",
                                                minWidth: "180px",
                                              }}
                                            >
                                              <div
                                                style={{
                                                  display: "-webkit-box",
                                                  WebkitBoxOrient: "vertical",
                                                  WebkitLineClamp: 2,
                                                  overflow: "hidden",
                                                  textOverflow: "ellipsis",
                                                  whiteSpace: "normal",
                                                }}
                                                title={
                                                  group?.makeItem?.item_code ||
                                                  "N/A"
                                                }
                                              >
                                                {group?.makeItem?.item_code ||
                                                  "N/A"}
                                              </div>
                                            </td>
                                            {/* <td>{"-"}</td> */}
                                            <td
                                              style={{
                                                paddingLeft: "10px",
                                                paddingRight: "2px",
                                                minWidth: "180px",
                                              }}
                                            >
                                              {" "}
                                              <div
                                                style={{
                                                  display: "-webkit-box",
                                                  WebkitBoxOrient: "vertical",
                                                  WebkitLineClamp: 2,
                                                  overflow: "hidden",
                                                  textOverflow: "ellipsis",
                                                  whiteSpace: "normal",
                                                }}
                                                title={
                                                  group?.makeItem
                                                    ?.make_item_desc || "N/A"
                                                }
                                              >
                                                {group?.makeItem
                                                  ?.make_item_desc || "N/A"}
                                              </div>
                                            </td>
                                            <td
                                              style={{
                                                paddingLeft: "10px",
                                                paddingRight: "2px",
                                                minWidth: "100px",
                                              }}
                                            >
                                              {" "}
                                              {group?.makeItem?.make_item_uom ||
                                                "N/A"}
                                            </td>
                                            <td>{"-"}</td>
                                            <td>{"-"}</td>
                                            <td>{"-"}</td>
                                          </tr>
                                        )}

                                        {group?.buyItems
                                          ?.filter((item) => item.is_make_item)
                                          ?.map((row, subIndex) => (
                                            <tr
                                              key={row.unique_id}
                                              style={{
                                                borderBottom: "1px solid #ccc",
                                              }}
                                            >
                                              <td>{`${serialNumber - 1}.${
                                                subIndex + 1
                                              }`}</td>
                                              {/* <td></td> */}
                                              <td
                                                style={{
                                                  paddingLeft: "10px",
                                                  paddingRight: "2px",
                                                  minWidth: "180px",
                                                }}
                                              >
                                                <div
                                                  style={{
                                                    display: "-webkit-box",
                                                    WebkitBoxOrient: "vertical",
                                                    WebkitLineClamp: 2,
                                                    overflow: "hidden",
                                                    textOverflow: "ellipsis",
                                                    whiteSpace: "normal",
                                                  }}
                                                  title={
                                                    row?.buy_item_code || "N/A"
                                                  }
                                                >
                                                  {row?.buy_item_code || "N/A"}
                                                </div>
                                              </td>
                                              <td
                                                style={{
                                                  paddingLeft: "10px",
                                                  paddingRight: "2px",
                                                  minWidth: "180px",
                                                }}
                                              >
                                                <div
                                                  style={{
                                                    display: "-webkit-box",
                                                    WebkitBoxOrient: "vertical",
                                                    WebkitLineClamp: 2,
                                                    overflow: "hidden",
                                                    textOverflow: "ellipsis",
                                                    whiteSpace: "normal",
                                                  }}
                                                  title={
                                                    row?.description || "N/A"
                                                  }
                                                >
                                                  {row?.description || "N/A"}
                                                </div>
                                              </td>
                                              <td
                                                style={{
                                                  paddingLeft: "10px",
                                                  paddingRight: "2px",
                                                  minWidth: "100px",
                                                }}
                                              >
                                                {row?.uom || "N/A"}
                                              </td>
                                              <td
                                                style={{
                                                  paddingLeft: "10px",
                                                  paddingRight: "2px",
                                                  minWidth: "100px",
                                                }}
                                              >
                                                {formatNumber(
                                                  row?.required_qty
                                                ) || 0}
                                              </td>

                                              <td
                                                style={{
                                                  paddingLeft: "10px",
                                                  paddingRight: "2px",
                                                  minWidth: "115px",
                                                }}
                                              >
                                                {formatNumber(
                                                  row?.assigned_qty
                                                )}
                                              </td>
                                              <td
                                                style={{
                                                  paddingLeft: "10px",
                                                  paddingRight: "2px",
                                                  minWidth: "115px",
                                                }}
                                              >
                                                {row?.already_installed_qty ||
                                                  0}
                                              </td>
                                            </tr>
                                          ))}
                                        {group?.buyItems
                                          ?.filter(
                                            (item) => item.is_make_item == false
                                          )
                                          ?.map((row, subIndex) => (
                                            <tr
                                              key={row.unique_id}
                                              style={{
                                                borderBottom: "1px solid #ccc",
                                              }}
                                            >
                                              <td>{serialNumber++}</td>

                                              <td
                                                style={{
                                                  paddingLeft: "10px",
                                                  paddingRight: "2px",
                                                  minWidth: "180px",
                                                }}
                                              >
                                                <div
                                                  style={{
                                                    display: "-webkit-box",
                                                    WebkitBoxOrient: "vertical",
                                                    WebkitLineClamp: 2,
                                                    overflow: "hidden",
                                                    textOverflow: "ellipsis",
                                                    whiteSpace: "normal",
                                                  }}
                                                  title={
                                                    row?.item_code || "N/A"
                                                  }
                                                >
                                                  {row?.item_code || "N/A"}
                                                </div>
                                              </td>

                                              <td
                                                style={{
                                                  paddingLeft: "10px",
                                                  paddingRight: "2px",
                                                  minWidth: "180px",
                                                }}
                                              >
                                                <div
                                                  style={{
                                                    display: "-webkit-box",
                                                    WebkitBoxOrient: "vertical",
                                                    WebkitLineClamp: 2,
                                                    overflow: "hidden",
                                                    textOverflow: "ellipsis",
                                                    whiteSpace: "normal",
                                                  }}
                                                  title={
                                                    row?.description || "N/A"
                                                  }
                                                >
                                                  {row?.description || "N/A"}
                                                </div>
                                              </td>
                                              <td
                                                style={{
                                                  paddingLeft: "10px",
                                                  paddingRight: "2px",
                                                  minWidth: "100px",
                                                }}
                                              >
                                                {row?.uom || "N/A"}
                                              </td>
                                              <td
                                                style={{
                                                  paddingLeft: "10px",
                                                  paddingRight: "2px",
                                                  minWidth: "100px",
                                                }}
                                              >
                                                {formatNumber(
                                                  row?.required_qty
                                                )}
                                              </td>
                                              <td
                                                style={{
                                                  paddingLeft: "10px",
                                                  paddingRight: "2px",
                                                  minWidth: "100px",
                                                }}
                                              >
                                                {formatNumber(
                                                  row?.assigned_qty
                                                )}
                                              </td>
                                              <td
                                                style={{
                                                  paddingLeft: "10px",
                                                  paddingRight: "2px",
                                                  minWidth: "100px",
                                                }}
                                              >
                                                {formatNumber(
                                                  row?.already_installed_qty
                                                )}
                                              </td>
                                            </tr>
                                          ))}
                                      </React.Fragment>
                                    )
                                  )
                                )}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </Row>
                      <Row className="mt-4">
                        <div className="payment-details-card p-3">
                          <h6 className="h-6-heading">Images</h6>
                          <div className="row mt-2">
                            {formData?.inputData &&
                            formData?.inputData?.installations?.file?.length >
                              0 ? (
                              formData.inputData.installations.file.map(
                                (item, index) => (
                                  <div
                                    className="col-md-6 col-lg-2"
                                    key={index}
                                  >
                                    <div
                                      className="card"
                                      style={{
                                        marginBottom: "20px",
                                        borderRadius: "5px",
                                        border: "1px solid #ddd",
                                        overflow: "hidden",
                                        transition:
                                          "transform 0.3s ease, box-shadow 0.3s ease",
                                        cursor: "pointer",
                                      }}
                                      onMouseEnter={(e) =>
                                        (e.currentTarget.style.transform =
                                          "scale(1.05)")
                                      }
                                      onMouseLeave={(e) =>
                                        (e.currentTarget.style.transform =
                                          "scale(1)")
                                      }
                                    >
                                      <div
                                        className="card-body"
                                        style={{
                                          padding: "16px",
                                          backgroundColor: "#fff",
                                          textAlign: "center",
                                        }}
                                      >
                                        <img
                                          onClick={() =>
                                            handleImageClick(
                                              baseURL + item.filePath
                                            )
                                          }
                                          src={baseURL + item.filePath}
                                          alt="Installation Image"
                                          style={{
                                            width: "100%",
                                            height: "150px",
                                            borderRadius: "5px",
                                          }}
                                        />
                                      </div>
                                    </div>
                                  </div>
                                )
                              )
                            ) : (
                              <div className="col-12 text-center">
                                <div
                                  style={{
                                    padding: "20px",
                                    backgroundColor: "#f8f9fa",
                                    borderRadius: "8px",
                                    boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                                    color: "#6c757d",
                                  }}
                                >
                                  No data available.
                                </div>
                              </div>
                            )}
                          </div>
                        </div>
                      </Row>
                      {formData.inputData.installations.status ==
                        "installation_completed" && (
                        <>
                          <Row className="mt-3">
                            <Col md="4">
                              <TextAreaInput
                                label="Remark"
                                name="remark"
                                value={remark}
                                onChange={onInputChange}
                                parentClassName=""
                                inputClassName="form-control"
                                labelClassName="form-label"
                                placeholder="Remark"
                              />
                            </Col>
                          </Row>

                          <div className="d-flex justify-content-center flex-grow-1">
                            <Button
                              color="success"
                              style={{ height: "40px" }}
                              className="waves-effect waves-light me-1 back-button ml-2"
                              onClick={() =>
                                handleApproveRejectInstallation("approve")
                              }
                            >
                              Approve
                            </Button>
                            <Button
                              color="danger"
                              style={{ height: "40px" }}
                              className="waves-effect waves-light me-1 back-button ml-2"
                              onClick={() =>
                                handleApproveRejectInstallation("reject")
                              }
                            >
                              Reject
                            </Button>
                          </div>
                        </>
                      )}
                    </AvForm>
                    {/* Loader Overlay */}
                    {loadingData && (
                      <div style={loaderOverlay}>
                        <LoaderCreatePage />
                      </div>
                    )}
                  </div>
                  <div
                    style={{
                      display: "none",
                      position: "absolute",
                      left: "-9999px",
                    }}
                    id="pdfContent"
                  >
                    <InstallationApprovalPDF
                      data={formData.inputData}
                      groupedItems={groupedItems}
                    />
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default InstallationApprovalView;
